import { api } from "./api";
import { calculateCurrentBalance } from "./rev2/BillingForm";

const CheckBalance = async (): Promise<boolean> => {
    const balance = await api.getBalance();
    return !!balance ? calculateCurrentBalance(balance, new Date()) > 0 : true;

    // return !!balance && balance?.value <= 0;
    // if (!!balance && balance?.value <= 0)
    //     return confirm("Средств не достаточно. Вы хотите пополнить счет?")
    // else
    //     return true;
}

export default CheckBalance;
